import type { TFunction } from 'i18next';

export const MATCHMAKING_INSUFFICIENT_BALANCE_ERROR = 'Insufficient balance';

export const MATCHMAKING_SEARCHING_FOR_OPPONENT_MESSAGE =
  'Searching for opponent...';

export const MATCHMAKING_STARTING_FREE_PLAY_MESSAGE = 'Starting free play...';

const MATCHMAKING_SEARCH_MESSAGE_KEYS: Record<string, string> = {
  [MATCHMAKING_SEARCHING_FOR_OPPONENT_MESSAGE]: 'search.searchingForOpponent',
  [MATCHMAKING_STARTING_FREE_PLAY_MESSAGE]: 'search.startingFreePlay',
};

const MATCHMAKING_ERROR_KEYS: Record<string, string> = {
  [MATCHMAKING_INSUFFICIENT_BALANCE_ERROR]: 'error.insufficientBalance',
  'Connection failed': 'error.connectionFailed',
  'Unknown error': 'error.unknown',
  'Failed to cancel search': 'error.cancelSearchFailed',
  'Cannot open active game: active game id is missing':
    'error.activeGameIdMissing',
  'Cannot open active game: game slug is missing':
    'error.activeGameSlugMissing',
  'Rematch is unavailable: missing lobby id': 'error.rematchUnavailable',
  'Failed to request rematch': 'error.rematchRequestFailed',
  'Rematch request was declined': 'error.rematchDeclined',
  'Rematch request is no longer available': 'error.rematchUnavailableExpired',
  'Failed to cancel rematch': 'error.rematchCancelFailed',
  'Rematch request timed out': 'error.rematchTimedOut',
  'Your search has been cancelled': 'search.cancelledMessage',
};

export function translateMatchmakingSearchMessage(
  t: TFunction<'matchmaking'>,
  message: string | null | undefined,
): string | undefined {
  if (!message) {
    return undefined;
  }

  const key = MATCHMAKING_SEARCH_MESSAGE_KEYS[message];
  if (key) {
    return t(key);
  }

  return message;
}

export function translateMatchmakingError(
  t: TFunction<'matchmaking'>,
  error: string | null | undefined,
): string {
  if (!error) {
    return t('error.generic');
  }

  const key = MATCHMAKING_ERROR_KEYS[error];
  if (key) {
    return t(key);
  }

  return error;
}

export function isMatchmakingInsufficientBalanceError(
  error: string | null | undefined,
): boolean {
  return error === MATCHMAKING_INSUFFICIENT_BALANCE_ERROR;
}
